<template>
  <component
    :is="to && !disabled ? RouterLink : 'div'"
    :to="to"
    class="__menu-item"
    :class="{ disabled }"
    @click="action"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { RouterLink } from 'vue-router'

const props = withDefaults(defineProps<{
  closeOnSelect?: boolean
  disabled?: boolean
  to?: string
}>(), {
  closeOnSelect: true,
  disabled: false,
  to: undefined
})

const emit = defineEmits(['action'])
const parentMenu = inject('UiMenu', {
  closeOnSelect: true,
  close: () => {}
})

const action = (event: Event) => {
  if (props.disabled) return event.stopImmediatePropagation()
    
  if (props.closeOnSelect && parentMenu.closeOnSelect) parentMenu.close()
  emit('action')
}
</script>

<style lang="scss">
.__menu-item {
  @apply block rounded-md px-4 py-2 text-inherit no-underline transition-colors;
  &:not(.disabled) {
    @apply cursor-pointer hover:bg-[#F3F3F3] hover:text-[#1D1D1D] dark:hover:bg-[#3D3D3D] dark:hover:text-[#F3F3F3];
  }
  &.disabled {
    @apply cursor-not-allowed text-[#A0AEC0] dark:text-[#718096];
  }
}
</style>
